var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { BasicLoader } from './components/Loader';
import { OktaAuth } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeContext, activeTheme } from '@justisom/nas-dev-nastech-ui';
import { HttpClientProvider } from './Contexts/HttpClientContext';
import { ReducerProvider } from './Contexts/ReducerContext';
import { AuthProvider } from './Contexts/AuthContext';
import { EventSnackbarProvider } from './Contexts/EventSnackbarContext';
import { Outlet } from '@tanstack/react-router';
var queryClient = new QueryClient();
var oktaCfg = {
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: window.location.origin + '/oidc/callback',
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
    tokenManager: {
        autoRenew: false,
        storage: 'sessionStorage'
    },
    services: {
        autoRenew: false
    }
};
// this is an example of a palette override.
var theColors = {
    light: { PrimaryButtonText: "#4E6F8D" },
    dark: {}
};
var mode = false;
var colorDefaults = { light: {}, dark: {} };
var thm = activeTheme(theColors, mode);
// const thm = activeTheme(theColors, mode); // to use the override palette instead
var defaultTheme = {
    mode: mode,
    toggleMode: function () { },
    theme: thm
};
var RootComponent = function () {
    var oktaAuth = new OktaAuth(oktaCfg);
    var restoreOriginalUri = function (_oktaAuth, originalUri) { return __awaiter(void 0, void 0, void 0, function () {
        var savedUri;
        return __generator(this, function (_a) {
            try {
                savedUri = originalUri || localStorage.getItem("originalUri") || '/';
                window.location.href = savedUri;
            }
            catch (error) {
                console.error('Error in restoreOriginalUri:', error);
                window.location.href = '/';
            }
            return [2 /*return*/];
        });
    }); };
    return (_jsx(ReducerProvider, { children: _jsx(EventSnackbarProvider, { children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(ThemeContext.Provider, { value: defaultTheme, children: _jsx(Security, { oktaAuth: oktaAuth, restoreOriginalUri: restoreOriginalUri, children: _jsx(HttpClientProvider, { children: _jsx(AuthProvider, { children: _jsx("div", { id: "app-root-container", children: _jsx(Suspense, { fallback: _jsx(BasicLoader, {}), children: _jsx(Outlet, {}) }) }) }) }) }) }) }) }) }));
};
export default RootComponent;
